export default __webpack_public_path__ + "static/4-523444f1876acace5cfc87b6015f1cfc.jpg";